import React, { Fragment } from "react"
import classnames from "classnames"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import ThemeConsumer from "shared/components/ThemeConsumer"
import LogoutButton from "components/LogoutButton"
import Link from "shared/components/Link"
import ToolbarSkeleton from "components/Skeleton/ToolbarSkeleton"
import NotificationUser from "components/Masthead/components/NotificationUser"
import NotificationFixedVoice from "components/Masthead/components/NotificationFixedVoice"

import { logout, saveOperation } from "services/state/actions"

import {
  HEADER_LINK_REDIRECT_LOGO,
  HEADER_BUTTON_LOGOUT
} from "shared/constants/idsElements"

import ENV from "../../../envProperties"

const Header = ({
  theme,
  icons,
  t,
  logout,
  bills,
  isLoading,
  location,
  ...props
}) => {
  if (isLoading) {
    return <ToolbarSkeleton />
  }

  const { Logo, Sair } = icons
  const gridDefaultClasses = classnames(
    "Grid Grid-cell--center",
    theme.defaultSizeLayout,
    theme.maxHeight
  )

  const headerClasses = classnames(theme.masterhead)
  const containerHeaderClasses = classnames(
    gridDefaultClasses,
    "Grid--alignMiddle u-flexJustifyBetween"
  )

  const containerItems = classnames(
    "Grid-cell u-size6of12 u-flex u-flexAlignItemsCenter u-flexJustifyEnd"
  )

  return (
    <Fragment>
      <header className={headerClasses}>
        <div className={containerHeaderClasses}>
          <Link
            id={HEADER_LINK_REDIRECT_LOGO}
            className={containerIcon}
            isExternal
            to={`${ENV.URL_NEW_B2B}/`}
          >
            <Logo />
          </Link>

          <div className={containerItems}>
            <LogoutButton
              id={HEADER_BUTTON_LOGOUT}
              classNames={theme.ml3}
              icon={Sair}
            />
          </div>
        </div>
      </header>

      <NotificationUser />

      {location.pathname === "/fixed-voice" && <NotificationFixedVoice />}
    </Fragment>
  )
}

const containerIcon = classnames("Grid-cell u-size2of12")

Header.propTypes = {
  theme: PropTypes.object.isRequired,
  icons: PropTypes.shape({
    Logo: PropTypes.func,
    Sair: PropTypes.func
  }),
  t: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  bills: PropTypes.array,
  isLoading: PropTypes.bool,
  location: PropTypes.object
}

const mapStateToProps = ({ bills, customer }) => ({
  bills: bills.data,
  customer: customer.data,
  isLoading: customer.loading || bills.loading
})

const enhance = compose(
  translate(),
  withRouter,
  connect(mapStateToProps, { logout, saveOperation })
)

export default enhance(ThemeConsumer("UIHeader")(Header))



// WEBPACK FOOTER //
// ./src/components/ModernLayout/Header/index.js